import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#15978a",
    },
  },
  typography: {
    fontFamily: '"Source Sans Pro", sans-serif',
    h1: {
      fontWeight: 600,
    },
    h2: {
      fontWeight: 600,
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
      fontSize: "16px",
    },
    p: {
      fontSize: "16px",
    },
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        outlined: {
          transform: "translate(14px, 12px) scale(1)",
          "&.MuiInputLabel-shrink": {
            transform: "translate(14px, -9px) scale(0.75)",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
          minHeight: "48px",
          "&.MuiInputBase-sizeSmall": {
            minHeight: "48px",
          },
          "&.MuiInputBase-multiline": {
            height: "auto",
            padding: 0,
          },
        },
        input: {
          padding: "12px 14px",
          boxSizing: "border-box",
        },
        inputSizeSmall: {
          padding: "12px 14px",
        },
        multiline: {
          padding: "12px 14px",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          display: "flex",
          alignItems: "center",
          boxSizing: "border-box",
          padding: "12px 14px",
          height: "48px",
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            padding: "0 14px !important",
            height: "48px",
          },
          "& .MuiOutlinedInput-root .MuiAutocomplete-input": {
            padding: "12px 0 !important",
            height: "100%",
            boxSizing: "border-box",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: "500",
          borderRadius: "8px",
        },
      },
    },
  },
});

export default theme;
